// import { AppState } from "./app-state";

export const actions = {
    // setPage: (page: AppPage) => (state: AppState) => ({ ...state, page })
};

export type Actions = typeof actions;
